class SaveDesignTrigger extends HTMLElement {
  constructor() {
    super();

    this.handleCanvasModalToggleBinder =
      this.handleCanvasModalToggle.bind(this);
    this.handleWizardChangeBinder = this.handleWizardChange.bind(this);
    this.handleSaveBinder = this.handleSave.bind(this);
    this.handleMediaChangeBinder = this.handleMediaChange.bind(this);
    this.designStorage = new window.DesignStorage();
    this._currentDesignId = null;
    this._saveTimeout = null;
    this.productId = null;
    this.wizardSummary = [];
    this.saveDelay = 400;
    this.studioViewer = null;
    this.mediaData = {};
  }

  connectedCallback() {
    this.productId = this.getAttribute("data-product-id") || null;

    if (!this.productId) {
      console.warn("SaveDesignTrigger: No product ID found.");
    }

    this.addEventListener("click", this.handleSaveBinder);
    document.addEventListener("dyo-media:change", this.handleMediaChangeBinder);
    document.addEventListener("wizard:change", this.handleWizardChangeBinder);
    window.addEventListener(
      "canvas-modal-toggle",
      this.handleCanvasModalToggleBinder,
    );
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.handleSaveBinder);
    
    document.removeEventListener(
      "dyo-media:change", 
      this.handleMediaChangeBinder
    );

    document.removeEventListener(
      "wizard:change",
      this.handleWizardChangeBinder,
    );
    window.removeEventListener(
      "canvas-modal-toggle",
      this.handleCanvasModalToggleBinder,
    );
  }

  handleSave() {
    if (!this.productId) {
      console.warn("SaveDesignTrigger: No product ID found.");
      return;
    }

    this.debounceSave();
  }

  handleWizardChange(event) {
    const { summary } = event.detail || {};
    if (summary) {
      this.wizardSummary = summary;
    }
  }

  handleCanvasModalToggle(event) {
    const { isOpen } = event.detail || {};
    if (isOpen === false) {
      this._currentDesignId = null;
    }
  }

  handleMediaChange(event) {
    const mediaData = event.detail || {};
    if (mediaData) {
      this.mediaData = mediaData;
    }
  }

  closePdpCanvasModal() {
    const pdpModal = document.querySelector("pdp-canvas-modal.pdp-dyo-modal");
    if (pdpModal && typeof pdpModal.handleClose === "function") {
      pdpModal.handleClose();
    } else {
      console.warn(
        "SaveDesignTrigger: pdp-canvas-modal not found or handleClose not available.",
      );
    }
  }

  getViewerImageUrl() {
    this.studioViewer = document.querySelector(
      "viewer-modal[data-dyo-modal] studio-viewer",
    );
    return this.studioViewer?.getImageUrl() || null;
  }

  debounceSave() {
    if (this._saveTimeout) {
      clearTimeout(this._saveTimeout);
    }

    // Make the setTimeout callback async
    this._saveTimeout = setTimeout(async () => {
      try {
        // Await the IndexedDB save operation
        this._currentDesignId = await this.designStorage.save(
          this.productId,
          this.wizardSummary,
          this._currentDesignId,
          this.getViewerImageUrl(),
          this.mediaData
        );

        if (this._currentDesignId) {
          // Close modal only after the save is successful
          this.closePdpCanvasModal();
        } else {
          console.warn("SaveDesignTrigger: Design save returned null or undefined ID.");
        }
        
      } catch (error) {
        console.error("Auto-save failed:", error);
      } finally {
        this._saveTimeout = null;
      }
    }, this.saveDelay);
  }
}

if (!customElements.get("save-design-trigger")) {
  customElements.define("save-design-trigger", SaveDesignTrigger);
}
